import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const ProtectedRoute = ({ children, roles = [] }) => {
  const location = useLocation();
  const { isAuthenticated, hasRole, user } = useAuth();

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles.length > 0 && !hasRole(roles)) {
    return (
      <div className="card">
        <div className="card-body text-center">
          <h2 className="card-title">Access Denied</h2>
          <p>You don't have permission to access this page.</p>
          <p>Required role: {roles.join(' or ')}</p>
          <p>Your role: {user?.role}</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;